import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { ChevronDown } from "lucide-react";
import { fluxInputOutline, fluxInputSizes } from "../flux/variants.js";
export const Select = React.forwardRef(({ className = "", invalid = false, inputSize = "base", children, ...rest }, ref) => {
    return (_jsxs("div", { className: "relative", children: [_jsx("select", { ref: ref, "data-invalid": invalid ? "true" : undefined, className: [
                    fluxInputOutline,
                    fluxInputSizes[inputSize],
                    "cursor-pointer pr-9",
                    className,
                ].join(" "), ...rest, children: children }), _jsx(ChevronDown, { className: "pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-400", "aria-hidden": true })] }));
});
Select.displayName = "Select";
